import { useMutation, UseMutationResult } from '@tanstack/react-query';
import useApi from 'api/mavapi/useApi';
import { useOnErrorCallBack } from './useErrorHandling';
import React from 'react';
import { MisPortalService } from 'api/openapi';

export const useMISPortalApi = () => {
  const { handleRequest } = useApi();
  const { onErrorCallBack } = useOnErrorCallBack();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const useMisPortalGetApi = (): UseMutationResult<
    any, // Response type
    Error, // Error type
    {
      mISCode?: string;
    } // Variables type
  > => {
    return useMutation({
      mutationFn: async ({ mISCode }) => {
        // mISCode parameter use for later, now dummy code applied _code
        let _code = 'mis-portal';

        setIsLoading(true);
        const response = await handleRequest(
          MisPortalService.getApiMisPortal(_code),
        );
        return { data: response };
      },
      onSuccess: response => {
        setIsLoading(false);
        if (response && response.data.url) {
          // Open the url in a new tab
          window.open(response.data.url, '_blank');
        }
      },
      onError: error => {
        setIsLoading(false);
        onErrorCallBack(error);
      },
    });
  };
  return {
    useMisPortalGetApi,
    isLoading,
  };
};
